<template>
  <div class="xscontainer jsjiesh">

    <div class="jjdkfklsdf">
      <div class="jfdgfdgf">
        <el-page-header @back="goBack" :content="fenlei">
        </el-page-header>
      </div>
      <div v-html="dictms"></div>
      <SearchBox style="width: 100%"  @search="chaxunshipin"></SearchBox>
<!--      <div class="btme">{{shipins[0].biaoti}}</div>-->
<!--      <video ref="videoPlayer" class="bsdfgd" controls>-->
<!--        <source :src="getVideoUrlme(shipins[0].neirong)" type="video/mp4">-->
<!--      </video>-->
      <div class="uuerwe">
        <div class="bsdfsdfd" v-for="(item,index) in shipins" @click="gotoxq(shipins[index])">
          <div class="rewrwtwet">
            <video ref="videoPlayer" class="bsdfgd" controls controlslist="nodownload" >
              <source :src="getVideoUrlme(shipins[index].neirong)" type="video/mp4">
            </video>
          </div>
          <p class="dfsdfererwre" @click="gotoxq(shipins[index])">{{shipins[index].biaoti}}</p>
        </div>
      </div>
      <el-pagination
          align="center"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="currentPage1"
          :page-sizes="[12, 24, 36, 48]"
          :page-size="pagesize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1">
      </el-pagination>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
import SearchBox from "@/components/lianmeng/common/SearchBox";
export default {
  components:{SearchBox},
  data() {
    return {
      fenlei:'',
      shipins:[],
      pagesize1:12,
      currentPage1: 1,
      total1:0,
      currentText:'',
      dictms:'',
      fwcishu:0
    };
  },
  mounted() {
    this.dictms = this.$route.query.dictms;
    this.fenlei = this.$route.query.fenlei;
    this.queryshipin();
    this.tongji(this.fenlei);
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    chaxunshipin(stext){
      this.currentText = stext;
      this.queryshipinLike(stext);
    },
    queryshipinLike(stext) {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shipin/tShipin/list?_t=' + new Date().getTime() + '&column=id&order=asc&biaoti=*'+stext+'*&fenlei=' + this.fenlei + '&order=asc&pageNo=' + this.currentPage1 + '&pageSize=' + this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.shipins = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    handleSizeChange1(val) {
      this.pagesize1 = val;
      if(this.currentText){
        this.queryshipinLike(this.currentText);
      }else{
        this.queryshipin();
      }

    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      if(this.currentText){
        this.queryshipinLike(this.currentText);
      }else{
        this.queryshipin();
      }
    },
    gotoxq(item){
      this.$router.push({path:'/spbf',query:{currobj:item}});
    },
    goBack(){
      this.$router.back();
    },
    getVideoUrlme(neirong) {
      return this.GLOBAL.sys_addr + '/shipin/tShipin/video?spm=' + neirong;
    },
    queryshipin() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shipin/tShipin/list?_t=' + new Date().getTime() + '&column=id&order=asc&fenlei=' + this.fenlei + '&order=asc&pageNo=' + this.currentPage1 + '&pageSize=' + this.pagesize1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.shipins = response.data.result.records;
              that.currentPage1 = response.data.result.current;
              that.total1 = response.data.result.total;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    }
  }
};
</script>

<style scoped>
.jjdkfklsdf {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5rem;
}
.btme{
  width: 100%;
  font-size: 1.1rem;
  font-weight: bold;
  text-align: left;
}
.ggcs334{
  background-image: url('../../assets/xxkc/33@4x.png');
  background-size: 105%; /* 或contain */
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 30rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: end;
  padding: 0 0 6rem 3rem;
}
.playcs32 {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  box-shadow: 0px 0px 1px 0px #55a2da;
}
.uuerwe{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap:2%
}
.bsdfsdfd{
  width: 23%;
  display: flex;
  flex-direction: column;
  align-items: start;
}
.rewrwtwet{
  width: 100%;
  background-color: #3c77eb;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: bold;
}
.dfsdfererwre{
  width: 100%;
  text-align: center;
  margin-top:0.6rem;
  font-size: 0.8rem;

  white-space: nowrap;
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
}
.dfsdfererwre:hover{
  cursor: pointer;
  color: #0f7cf2;
}
.gg3{
  width: 100%;
  display: flex;
  flex:3;
  justify-content: space-between;
}
.mmlist{
  width: 30%;
}
.ljsdke{
  width: 100%;
  font-size: 0.8rem;
}

.kksc{
  font-size: 1.1rem;
  font-weight: bold;
  color: #ffffff;
}
.jfdgfdgf{
  width: 100%;
  display: flex;
  justify-content: start;
}
.bsdfgd {
  width: 100%;
  height: 100%;
}
</style>
